<template>
	<b-modal
		ref="averageWeightDetailModal"
		size="xl"
		title="REPORTE DE PESOS PROMEDIOS"
		hide-footer
		@hidden="$emit('close')"
		scrollable
	>
		<b-overlay :show="averageWeightLoadingMonthly">
			<b-row class="gap-y-1">
				<b-col cols="12" md="6">
					<h2 class="text-secondary font-weight-bolder">Pesos Promedios Mensuales</h2>
				</b-col>
				<b-col cols="12" md="6" class="d-flex justify-content-end align-items-center gap-x-2">
					<b-input-group size="sm" prepend="Categoría" style="max-width: 15rem">
						<b-form-select style="min-width: 6rem" :options="categoryOpts" v-model="categoryIdMonthly" />
					</b-input-group>
					<b-input-group size="sm" prepend="Año" style="max-width: 15rem">
						<b-form-select style="min-width: 6rem" :options="yearOpts" v-model="year" />
					</b-input-group>
				</b-col>
			</b-row>
			<hr />
			<div>
				<VueApexCharts type="bar" height="300" :options="chartOptsMonthly" :series="chartDataMonthly" />
			</div>
		</b-overlay>
		<b-overlay :show="averageWeightLoadingAnnual">
			<b-row class="gap-y-1">
				<b-col cols="12" md="6">
					<h2 class="text-secondary font-weight-bolder">Pesos Promedios Anuales</h2>
				</b-col>
				<b-col cols="12" md="6" class="d-flex justify-content-end align-items-center gap-x-2">
					<b-input-group size="sm" prepend="Categoría" style="max-width: 15rem">
						<b-form-select style="min-width: 6rem" :options="categoryOpts" v-model="categoryIdAnnual" />
					</b-input-group>
				</b-col>
			</b-row>
			<hr />
			<div>
				<VueApexCharts type="bar" height="300" :options="chartOptsAnnual" :series="chartDataAnnual" />
			</div>
		</b-overlay>
		<SpecimenWeightDetailModal
			v-if="showSpecimenWeightDetailModal"
			:month="selectedMonth"
			:year="year"
			:category-id="categoryIdMonthly"
			@close="showSpecimenWeightDetailModal = false"
		/>
	</b-modal>
</template>

<script>
import VueApexCharts from "vue-apexcharts"
import specimensService from "@/services/specimens.service"
import SpecimenWeightDetailModal from "@/views/amg/specimens/components/mainDashboard/average-weight/components/SpecimenWeightDetailModal.vue"
export default {
	components: { VueApexCharts, SpecimenWeightDetailModal },
	props: { info: Array, isLoading: Boolean },
	data: () => ({
		showSpecimenWeightDetailModal: false,
		selectedMonth: null,
		categoryIdMonthly: 1,
		categoryIdAnnual: 1,
		year: new Date().getFullYear(),
		monthOptsBase: [
			{ value: 1, text: "Enero" },
			{ value: 2, text: "Febrero" },
			{ value: 3, text: "Marzo" },
			{ value: 4, text: "Abril" },
			{ value: 5, text: "Mayo" },
			{ value: 6, text: "Junio" },
			{ value: 7, text: "Julio" },
			{ value: 8, text: "Agosto" },
			{ value: 9, text: "Septiembre" },
			{ value: 10, text: "Octubre" },
			{ value: 11, text: "Noviembre" },
			{ value: 12, text: "Diciembre" },
		],
		weightOpts: [
			{ value: 1, text: "Kilogramos" },
			{ value: 2, text: "Libras" },
		],
		yearOpts: Array.from({ length: new Date().getFullYear() - 2022 + 1 }, (_, i) => ({
			value: 2022 + i,
			text: (2022 + i).toString(),
		})),
		categoryOpts: [
			{ value: 1, text: "Padrillos" },
			{ value: 2, text: "Madrillas" },
			{ value: 3, text: "Gallos" },
			{ value: 4, text: "Gallinas" },
			{ value: 5, text: "Pollones" },
			{ value: 6, text: "Pollas" },
		],
		monthOpts: [
			{ value: 1, text: "Enero" },
			{ value: 2, text: "Febrero" },
			{ value: 3, text: "Marzo" },
			{ value: 4, text: "Abril" },
			{ value: 5, text: "Mayo" },
			{ value: 6, text: "Junio" },
			{ value: 7, text: "Julio" },
			{ value: 8, text: "Agosto" },
			{ value: 9, text: "Septiembre" },
			{ value: 10, text: "Octubre" },
			{ value: 11, text: "Noviembre" },
			{ value: 12, text: "Diciembre" },
		],
		chartDataMonthly: [
			{
				name: "Padrillos",
				data: [],
			},
			{
				name: "Madrillas",
				data: [],
			},
			{
				name: "Gallos",
				data: [],
			},
			{
				name: "Gallinas",
				data: [],
			},
			{
				name: "Pollones",
				data: [],
			},
			{
				name: "Pollas",
				data: [],
			},
		],
		chartOptsMonthly: {},
		chartDataAnnual: [
			{
				name: "Kg Peso Promedio",
				data: [],
			},
			{
				name: "Lb Peso Promedio",
				data: [],
			},
		],
		chartOptsAnnual: {},
		averageWeightLoadingMonthly: false,
		averageWeightInfoMonthy: [],
		averageWeightLoadingAnnual: false,
		averageWeightInfoAnnual: [],
	}),
	methods: {
		openSpecimenWeightDetailModal(month) {
			this.selectedMonth = month
			this.showSpecimenWeightDetailModal = true
		},
		async getComparativeReportOfAverageMonthlyWeights() {
			this.averageWeightLoadingMonthly = true
			const { data } = await specimensService.getComparativeReportOfAverageMonthlyWeights({
				year: this.year,
				category_id: this.categoryIdMonthly,
			})
			this.averageWeightInfoMonthy = data
			this.averageWeightLoadingMonthly = false
		},
		async getDataMonthly() {
			await this.getComparativeReportOfAverageMonthlyWeights()
			this.chartDataMonthly = [
				{
					name: "Kg Peso Promedio",
					data: this.averageWeightInfoMonthy.map((d) => d.avg_kg_weight),
				},
				{
					name: "Lb Peso Promedio",
					data: this.averageWeightInfoMonthy.map((d) => d.avg_pounds_weight),
				},
			]
			this.chartOptsMonthly = {
				labels: this.monthOptsBase.map((d) => d.text),
				colors: ["#00cfe8", "#28c76f", "#ff9f43", "#ea5455"],
				fill: {
					type: "gradient",
					gradient: {
						shade: "light",
						type: "horizontal",
						shadeIntensity: 0.25,
						gradientToColors: undefined,
						inverseColors: true,
						opacityFrom: 0.85,
						opacityTo: 0.85,
						stops: [50, 0, 100],
					},
				},
				chart: {
					events: {
						dataPointSelection: (event, chartContext, config) => {
							const month = config.dataPointIndex + 1
							this.openSpecimenWeightDetailModal(month)
						},
					},
				},
			}
		},

		async getComparativeReportOfAverageAnnualWeights() {
			this.averageWeightLoadingAnnual = true
			const { data } = await specimensService.getComparativeReportOfAverageAnnualWeights({
				category_id: this.categoryIdAnnual,
			})
			this.averageWeightInfoAnnual = data
			this.averageWeightLoadingAnnual = false
		},
		async getDataAnnual() {
			await this.getComparativeReportOfAverageAnnualWeights()
			this.chartDataAnnual = [
				{
					name: "Kg Peso Promedio",
					data: this.averageWeightInfoAnnual.map((d) => d.avg_kg_weight),
				},
				{
					name: "Lb Peso Promedio",
					data: this.averageWeightInfoAnnual.map((d) => d.avg_pounds_weight),
				},
			]
			this.chartOptsAnnual = {
				labels: this.averageWeightInfoAnnual.map((d) => d.year).sort((a, b) => a - b),
				colors: ["#00cfe8", "#28c76f", "#ff9f43", "#ea5455"],
				fill: {
					type: "gradient",
					gradient: {
						shade: "light",
						type: "horizontal",
						shadeIntensity: 0.25,
						gradientToColors: undefined,
						inverseColors: true,
						opacityFrom: 0.85,
						opacityTo: 0.85,
						stops: [50, 0, 100],
					},
				},
			}
		},
	},
	watch: {
		year() {
			this.getDataMonthly()
		},
		categoryIdMonthly() {
			this.getDataMonthly()
		},
		categoryIdAnnual() {
			this.getDataAnnual()
		},
	},
	async mounted() {
		await this.getDataAnnual()
		await this.getDataMonthly()
		this.$refs["averageWeightDetailModal"].toggle()
	},
}
</script>
